<template>
  <div>
    <page-title
      heading="Daftar Pasien"
      :breadcrumb="[
        {
          label: 'Daftar Pasien',
          link : '/pasien-klinik'
        },
        {
          label: 'edit Pasien',
          active: true
        }
      ]"
    />

    <div class="container-fluid">
      <div class="card card-box">
        <div class="card-header">
          <h4 class="text-capitalize my-2">edit pasien</h4>
        </div>
        <div class="card-body">
          <PasienForm
            formType="edit"
            @keluar="goingPlaces"
            @submitForm="submitForm"
            :idPasien="idPasien"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import startCase from "lodash/startCase";
import pasienMixin from "./mixins";

export default {
  mixins: [pasienMixin],
  components: {
    PasienForm: () => import("./PasienForm")
  },
  data: () => ({
    dropzoneOptions: {
      url: "https://httpbin.org/post",
      thumbnailWidth: 150,
      maxFilesize: 0.5,
      headers: { "My-Awesome-Header": "header value" }
    },
    beingSubmit: false,
    idPasien: null
  }),
  computed: {
    ...mapGetters(["getKlinikId"])
  },
  beforeRouteLeave(to, from, next) {
    if (!this.beingSubmit && localStorage.getItem('IDLE') != 1) {
      this.$swal({
        title: startCase("keluar"),
        html: `Apakah Anda yakin untuk keluar dari halaman ini?<br>Data yang telah ditulis tidak akan tersimpan.`,
        type: "warning",
        showCancelButton: true,
        cancelButtonText: startCase("tidak"),
        confirmButtonText: startCase("ya")
      }).then(res => {
        if (res.value) {
          next();
        } else {
          next(false);
        }
      });
    } else {
      next();
    }
  },
  beforeRouteEnter(to, from, next) {
    const { params } = to;
    const { idPasien } = params;
    if (!idPasien) {
      next({
        name: "pasien-klinik-list"
      });
    } else {
      next();
    }
  },
  mounted() {
    this.idPasien = this.$router.currentRoute.params.idPasien;
  },
  methods: {
    simpan() {
      this.$swal({
        text: `Data Berhasil disimpan`,
        type: "success"
      });
    },
    submitForm(data) {
      this.beingSubmit = true;
      this.editPasien(data);
    },
    goingPlaces() {
      const tmp = {
        name: "pasien-klinik-list"
      };
      if (this.beingSubmit && localStorage.getItem('IDLE') != 1) {
        tmp.onComplete = this.simpan();
      }
      this.$router.push(tmp);
    },
    async editPasien(postData) {
      try {
        const res = await this.$axios.put(
          `pasien/${this.idPasien}?klinik_id=${this.getKlinikId}`,
          this.mapPasienFormData(postData)
        );
        const { status, data } = res.data;
        if (status) {
          this.goingPlaces();
        }
      } catch (err) {
        alert(err);
      } finally {
        this.beingSubmit = false;
      }
    }
  }
};
</script>
<style lang="scss">
.custom-dropzone {
  .dz-message {
    padding: 10rem 1rem;
  }
}
</style>
